import { render, staticRenderFns } from "./DemoChart.vue?vue&type=template&id=4a81f92a&scoped=true&"
import script from "./DemoChart.vue?vue&type=script&lang=js&"
export * from "./DemoChart.vue?vue&type=script&lang=js&"
import style0 from "./DemoChart.vue?vue&type=style&index=0&id=4a81f92a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a81f92a",
  null
  
)

export default component.exports